module.exports = __webpack_public_path__ + "img/order.cdc6c4e9.png";